import React from "react";
import { Draggable } from "@hello-pangea/dnd";
import ISerialWorkflowStep from "../../../../models/ISerialWorkflowStep";
import OwButton from "../../../shared/OwButton/OwButton";

type Props = {
    step: ISerialWorkflowStep;
    index: number;
    onEdit: (step: ISerialWorkflowStep) => void;
    onDeactivate: (step: ISerialWorkflowStep) => void;
};

const SerialWorkflowStepRow: React.FC<Props> = ({ step, index, onEdit, onDeactivate }) => {
    const isInactive = step.is_active === false;

    return (
        <Draggable draggableId={String(step.id)} index={index}>
            {(provided, snapshot) => (
                <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    className={`serial-workflow-step-row d-flex align-items-center p-2 mb-1 rounded ${
                        snapshot.isDragging ? "dragging" : ""
                    } ${isInactive ? "inactive" : ""}`}>
                    <div {...provided.dragHandleProps} className="drag-handle me-2">
                        <i className="fad fa-grip-vertical" />
                    </div>

                    <div className="flex-grow-1 d-flex align-items-center">
                        <span className={`step-name me-2 ${isInactive ? "text-muted text-decoration-line-through" : ""}`}>{step.name}</span>

                        {step.is_production_start && (
                            <span className="badge bg-success me-1">
                                <i className="fad fa-play-circle me-1" />
                                Serials start here
                            </span>
                        )}

                        {step.is_terminal && (
                            <span className="badge bg-primary me-1">
                                <i className="fad fa-flag-checkered me-1" />
                                Ready to ship
                            </span>
                        )}

                        {isInactive && <span className="badge bg-secondary me-1">Inactive</span>}
                    </div>

                    <div className="step-actions d-flex">
                        <OwButton
                            centerIconClass={"fas fa-pencil"}
                            className={"btn-sm btn-outline-secondary me-1"}
                            fn={() => onEdit(step)}
                        />
                        {!isInactive && (
                            <OwButton
                                centerIconClass={"fas fa-times"}
                                className={"btn-sm btn-outline-danger"}
                                fn={() => onDeactivate(step)}
                            />
                        )}
                    </div>
                </div>
            )}
        </Draggable>
    );
};

export default SerialWorkflowStepRow;
